import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, update, remove } from 'firebase/database';
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from 'firebase/messaging';
import {
  getAnalytics,
  isSupported as analyticsSupported,
} from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyDm5ivgv258DG0-JgSK3qBZ51niyQodANY',
  authDomain: 'azan-time-app.firebaseapp.com',
  databaseURL: 'https://azan-time-app-default-rtdb.firebaseio.com',
  projectId: 'azan-time-app',
  storageBucket: 'azan-time-app.firebasestorage.app',
  messagingSenderId: '933825769707',
  appId: '1:933825769707:web:316743ff5dbfc79a4a8eae',
  measurementId: 'G-CXCQ1341FE',
};

// Init Firebase
const app = initializeApp(firebaseConfig);

// DB
const db = getDatabase(app);

// Analytics
let analytics = null;
analyticsSupported().then((ok) => {
  if (ok) analytics = getAnalytics(app);
});

// Messaging
let messaging = null;
isSupported().then((ok) => {
  if (ok) messaging = getMessaging(app);
});

// --------------------------------------------------
// Get FCM token
// --------------------------------------------------
export const requestPermissionAndGetToken = async () => {
  if (!messaging) return null;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return null;

  // Ensure service worker exists
  let reg =
    (await navigator.serviceWorker.getRegistration(
      '/firebase-messaging-sw.js',
    )) || (await navigator.serviceWorker.register('/firebase-messaging-sw.js'));

  const token = await getToken(messaging, {
    vapidKey:
      process.env.REACT_APP_FIREBASE_VAPID_KEY ||
      'BKk6LBM3AXV7yHGjbpCQDmSBKHNddRIP-mxAhTcLC9C16TA4TSw4rFXehp7ujD7rMCtuhjpNHwfKtw8YjSJfIWs',
    serviceWorkerRegistration: reg,
  });

  return token;
};

// --------------------------------------------------
// Save Token + Reminder Preferences
// --------------------------------------------------
export const saveFcmToken = async (emailOrAnon, token, prefs = {}) => {
  const key = emailOrAnon
    ? emailOrAnon.replace(/\./g, '_')
    : `anon_${Date.now()}`;

  await set(ref(db, `fcmTokens/${key}`), {
    token,
    minutesBefore: prefs.minutesBefore ?? 60,
    updatedAt: new Date().toISOString(),
  });

  return key;
};

// Update reminder time
export const updateFcmPrefs = async (key, prefs = {}) => {
  if (!key) return;

  await update(ref(db, `fcmTokens/${key}`), {
    minutesBefore: prefs.minutesBefore,
    updatedAt: new Date().toISOString(),
  });
};

// Disable token
export const disableFcmToken = async (key) => {
  if (!key) return;
  await remove(ref(db, `fcmTokens/${key}`));
};

// Foreground listener
export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => resolve(payload));
  });

export { db, analytics, messaging };
